import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {isInt} from 'validator';
import {GreatForm} from 'components/common';
import {InputField, CounterField} from 'components/common/rc-fields';
import {updateClassroomStudentReadingNights} from 'api/classrooms';

const ClassroomAdminReadingNightsForm = ({classroomId, form, initialValues, onCancel, onSubmitSuccess}) => {
  const isUpdate = !isEmpty(initialValues);
  const {baseReadingDates} = initialValues || {};

  return (
    <GreatForm
      form={form}
      onCancel={onCancel}
      submitFn={(payload) => updateClassroomStudentReadingNights(classroomId, initialValues.id, payload)}
      onSuccess={onSubmitSuccess}
      successMsg={`Reading nights has been ${isUpdate ? 'updated' : 'created'} successfully`}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Your current base reading nights is
            <Typography component="span" color="primary">
              {' '}
              {baseReadingDates}
            </Typography>
            . Would you like to continue increasing or decreasing base reading nights?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <CounterField
            form={form}
            name="baseReadingNights"
            label="Increase or Decrease Base Reading Nights"
            rules={[{required: true, message: 'Please select a valid Base Reading Nights'}]}
            initialValue={baseReadingDates || 0}
          />
          {/*<InputField*/}
          {/*  name="baseReadingNights"*/}
          {/*  label="Base Reading Nights"*/}
          {/*  initialValue={baseReadingDates ? baseReadingDates.toString() : '0'}*/}
          {/*  form={form}*/}
          {/*  rules={[*/}
          {/*    {required: true, message: 'Please enter Base Reading Nights'},*/}
          {/*    {*/}
          {/*      validator(rule, value, callback) {*/}
          {/*        const errors = [];*/}
          {/*        if (value && !isInt(value, {min: 0})) {*/}
          {/*          errors.push('Please enter a valid Base Reading Nights');*/}
          {/*        }*/}
          {/*        callback(errors);*/}
          {/*      },*/}
          {/*    },*/}
          {/*  ]}*/}
          {/*/>*/}
        </Grid>
      </Grid>
    </GreatForm>
  );
};

ClassroomAdminReadingNightsForm.propTypes = {
  form: formShape.isRequired,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmitSuccess: PropTypes.func.isRequired,
  classroomId: PropTypes.number.isRequired,
};

ClassroomAdminReadingNightsForm.defaultProps = {
  initialValues: {},
};

export default createForm()(ClassroomAdminReadingNightsForm);
